import ImageLoader from './ImageLoader'

// lightgallery renders data-sub-html as HTML: escape the caption (listing titles come from the API)
const escapeHtml = (text = '') => String(text)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;')

const GalleryItem = ({
  thumb,
  video,
  imgAlt,
  caption,
  light,
  className,
  ...props
}) => (
  <a
    {...props}
    data-sub-html={`<h6 class='fs-sm text-light'>${escapeHtml(imgAlt ? imgAlt : caption)}</h6>`}
    className={`gallery-item d-flex${video ? ' video-item' : ''}${className ? ` ${className}` : ''}`}
  >
    {thumb && <ImageLoader
      src={thumb[0]}
      width={thumb[1]}
      height={thumb[2]}
      alt={caption ? caption : imgAlt}
      light={light ? 1 : 0}
    />}
    {caption && <span className='gallery-item-caption'>{caption}</span>}
  </a>
)

export default GalleryItem
